module.exports = "/images/login-input-1.png?33e7dae86d410549399b4357870f9b4c";